import React, { useContext } from "react";
import styles from "./styles/OnProgress.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { useScrollLock } from "../../../Utils/useScrollLock";
function OnProgress({ status, title, text, subtext }) {
  console.log(status);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const dublicatedcontent = websiteCurrentLang.content.DublicatedText;
  // Counted: this is rendered INSIDE the asset modals, and releasing the lock
  // outright on close left the page scrolling behind them.
  useScrollLock();
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
        style={{
          zIndex: "35",
        }}
      >
        <div className={styles.title}>
          {title || dublicatedcontent?.work_in_progress}
        </div>
        <div className={styles.title_small}>
          {text || dublicatedcontent?.do_not_close_tab_or_browser}
        </div>
        <div className={styles.title1_small}>
          {subtext || dublicatedcontent?.wait_until_process_ends}
        </div>
        <div className={`${styles.title1} ${styles.status}`}>
          {status}
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
        </div>
      </div>
    </div>
  );
}
export { OnProgress };
